const state = {
  items: [],
  title: 'example state'
}

export default {
  namespaced: true,
  state
}
